const Audio = (target) => {
  const initAudio = audio => {
    const btn = audio.querySelector('.audio__button')

    btn.addEventListener('click', () => toggleAudio(audio, btn));
    audio.addEventListener('ended', () => {
      audio.classList.remove('audio--playing')
    });
  };

  const toggleAudio = audio => {
    const track = audio.querySelector('.audio__element')

    if (track.paused) {
      track.play();
      audio.classList.add('audio--playing')
    } else {
      track.pause();
      audio.classList.remove('audio--playing')
    }
  }

  $('body').find(target)
    .each((_, el) => {
      initAudio(el);
    });
}

export default Audio;



// WEBPACK FOOTER //
// ./scripts/components/Audio.js